module.exports = __webpack_public_path__ + "img/img73.618f3df3.svg";